import React, { useState } from "react";
import FeaturePaywallModal from "../../../../components/popups/paywall/FeaturePaywallModal";
import {
  SOFT_WATERMARK_PREVIEW_BASE_INSET,
  SOFT_WATERMARK_TEXT,
} from "../../../../config/tools/softWatermarkBrand";
import "./SoftWatermarkOverlay.css";

function SoftWmCloseIcon() {
  return (
    <svg
      className="soft-wm-overlay__x-icon"
      viewBox="0 0 12 12"
      width="10"
      height="10"
      aria-hidden="true"
    >
      <path
        d="M2.5 2.5l7 7M9.5 2.5l-7 7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

/**
 * Preview-only LazyStudio soft watermark (bottom-right).
 * Matches free 1K download bake. X opens FeaturePaywallModal (clean download).
 *
 * @param {number} [edgeInset] — px from bottom/right (raise for round corners)
 */
const SoftWatermarkOverlay = ({
  visible = true,
  toolKey = "editing",
  className = "",
  edgeInset = SOFT_WATERMARK_PREVIEW_BASE_INSET,
}) => {
  const [paywallOpen, setPaywallOpen] = useState(false);

  if (!visible) return null;

  const inset = Math.max(
    0,
    Number.isFinite(Number(edgeInset))
      ? Number(edgeInset)
      : SOFT_WATERMARK_PREVIEW_BASE_INSET
  );
  const rootClass = ["soft-wm-overlay", className].filter(Boolean).join(" ");

  return (
    <>
      <div
        className={rootClass}
        style={{ right: inset, bottom: inset }}
        aria-label={`${SOFT_WATERMARK_TEXT} watermark`}
      >
        <div className="soft-wm-overlay__badge">
          <span className="soft-wm-overlay__text">{SOFT_WATERMARK_TEXT}</span>
          <button
            type="button"
            className="soft-wm-overlay__dismiss"
            aria-label="Remove watermark"
            title="Remove watermark"
            onClick={(e) => {
              e.stopPropagation();
              setPaywallOpen(true);
            }}
          >
            <SoftWmCloseIcon />
          </button>
        </div>
      </div>
      <FeaturePaywallModal
        open={paywallOpen}
        featureKey="remove_soft_watermark"
        toolKey={toolKey}
        onClose={() => setPaywallOpen(false)}
      />
    </>
  );
};

export default SoftWatermarkOverlay;
